// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Sidebar_sidebar__vtq0s {
    background-color: #ffffff;
    border-radius: 20px;
    padding: 20px;
    margin-bottom: 50px;
    border: 3px solid #4AAE9B;
  }`, "",{"version":3,"sources":["webpack://./src/Pages/Home/Pages/PackvideoPage/Packvideo/Sidebar/Sidebar.module.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,yBAAyB;EAC3B","sourcesContent":[".sidebar {\n    background-color: #ffffff;\n    border-radius: 20px;\n    padding: 20px;\n    margin-bottom: 50px;\n    border: 3px solid #4AAE9B;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sidebar": `Sidebar_sidebar__vtq0s`
};
export default ___CSS_LOADER_EXPORT___;
